import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { appTargetingAdverStatisticsData } from 'lib/api/datacenter';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const AppTargetingAdverStatistics = ({ extraCustomized }) => {
  const { t } = useTranslation();

  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    partnerId: 'all',
  };
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  const byappsOptions = [
    { value: 'byapps', label: t('ON') },
    { value: 'all', label: t('OFF') },
  ];

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
        <FilterCollection
          label={t('바이앱스')}
          value={params.state}
          name="partnerId"
          type="radio"
          params={params}
          list={byappsOptions}
          labelKey="label"
          valueKey="value"
          callBack={getParam}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={appTargetingAdverStatisticsData}
        customized={extraCustomized}
        useFetch={false}
        borderRangeStart={9}
        borderRangeEnd={11}
      />
    </>
  );
};

export default AppTargetingAdverStatistics;
